// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__a0TZf","panel":"Robot_panel__zvU2x","wrapper":"Robot_wrapper__cZdDj","info":"Robot_info__KRGKB","unit":"Robot_unit__j-wSA"};